import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { filter } from "lodash"

import Dropdown from "shared/components/Dropdown"
import DropdownTrigger from "shared/components/Dropdown/DropdownTrigger"
import DropdownContent from "shared/components/Dropdown/DropdownContent"
import Button from "shared/components/Button"

class ParcelsSwitcher extends PureComponent {
  static propTypes = {
    current: PropTypes.object.isRequired,
    list: PropTypes.array.isRequired,
  }

  render() {
    const { current, list } = this.props
    const filteredList = filter(list, trackingNumber => trackingNumber.tracking_number !== current.tracking_number)

    return (
      <Dropdown right>
        <DropdownTrigger>
          <Button color="default">
            <div className="inlineBlock textLeft textUppercase v-m">
              <span className="block fs-12 c-black">{current.tracking_number}</span>
              <span className="block fs-10 c-gray-dark">{current.provider_tracking_number}</span>
            </div>
            {" "}
            <span className="zmdi zmdi-chevron-down fs-20 v-m" />
          </Button>
        </DropdownTrigger>
        <DropdownContent>
          <ul className="l-unstyled">
            {filteredList.map(number => (
              <li value={number} key={`parcel_${number.tracking_number}`}>
                <Link to={`/parcel/${number.tracking_number}`}>
                  <span className="textUppercase">
                    {number.tracking_number}
                    <span className="block fs-10 c-gray-dark">
                      {number.provider_tracking_number}
                    </span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </DropdownContent>
      </Dropdown>
    )
  }
}

export default ParcelsSwitcher



// WEBPACK FOOTER //
// ./src/views/Parcel/components/ParcelsSwitcher/ParcelsSwitcher.js